export default __webpack_public_path__ + "static/media/Roel-Van-Hove.4806f584.jpg";